module.exports = __webpack_public_path__ + "static/media/programmaticplatform_circle.c9034845.png";